import {useMemo} from 'react'

import {useAppSelector} from '../../../../../../../hooks/react-redux'
import {getErrorJobs, getPipelineDraftDeleted} from '../../../EditPipelinePage.selectors'

import {emptyArray} from 'src/utils/empty'

function useSaveChangesError(pipelineId: string) {
  const deletedJobs = useAppSelector(getPipelineDraftDeleted(pipelineId))?.jobs ?? emptyArray
  const errorJobs = useAppSelector(getErrorJobs).filter(({jobId}) => !deletedJobs.includes(jobId))
  const isOnlyOneError = errorJobs.length === 1
  const [firstError] = errorJobs
  const firstErrorMessage = firstError?.message || ''
  const prefixErrorMessage = 'Invalid settings in '
  const errorJobsString = useMemo(() => {
    const jobIds = errorJobs.reduce<string[]>((accumulator, {jobId}) => {
      if (jobId) {
        accumulator.push(jobId)
      }

      return accumulator
    }, [])

    return [...new Set(jobIds)].join(', ')
  }, [errorJobs])
  const hasErrors = Boolean(errorJobs.length)
  const errorJobsLabel = useMemo(() => {
    if (isOnlyOneError && firstErrorMessage) {
      return `${firstErrorMessage} in the ${errorJobsString}`
    }
    return errorJobsString ? `${prefixErrorMessage} ${errorJobsString}` : ''
  }, [errorJobsString, firstErrorMessage, isOnlyOneError])

  return {
    hasErrors,
    errorJobsLabel,
  }
}

export default useSaveChangesError
